import { ENDPOINTS_LOANS } from 'common/endpoints/loans.endpoints';

// TODO: [Manu] Change this to close a module, until the client approves to call a http service instead.
const MODULE_CLOSED = {
  vacationsAbsences:  false,
  foodBenefit:        false,
  loans:              false,
  wageAdvance:        false,
  solidarityEuro:     false
};

class StatusAppCheckers {

  constructor($http, $q){
    'ngInject';
    this.http = $http;
    this.q = $q;
  }

  _getLoansStatus(){
    if (this.cacheLoansStatus !== undefined) {
      var deferred = this.q.defer();
      deferred.resolve(this.cacheLoansStatus);
      return deferred.promise;
    }

    return this.http.get(ENDPOINTS_LOANS.get.serviceClosed()).then((response)=>{
      this.cacheLoansStatus = response.data;
      return response.data;
    });
  }

  isWageInProcess(){
    return this._getLoansStatus().then((status)=>{
      return status.payrollUpdate;
    });
  }

  isServiceClosed(){
    return this._getLoansStatus().then((status)=>{
      return status.serviceClosed;
    });
  }

  getClosedModules(){
    return this._getLoansStatus().then((response)=>{
      if (process.env.isDev) {
        response.isFoodBenefitClosed = MODULE_CLOSED.foodBenefit;
        response.isVacationsAbsencesClosed = MODULE_CLOSED.vacationsAbsences;
        response.isWageAdvanceClosed = MODULE_CLOSED.wageAdvance;
        response.isSolidarityEuroClosed = MODULE_CLOSED.solidarityEuro;
        response.isLoansClosed = MODULE_CLOSED.loans;
      }
      return response;
    });
  }
}

export default StatusAppCheckers;



// WEBPACK FOOTER //
// ./client/app/common/services/statusAppCheckers.service.js